import type { BaseItemContent, BaseItemSchema } from "@memorang/types";

type MediaItem = { id: string; url: string; caption?: string };

const isAudio = (m: { type: string }) =>
	m.type === "AUDIO" || m.type === "audio";

const isImage = (m: { type: string }) =>
	m.type === "IMAGE" || m.type === "image";

const isVideo = (m: { type: string }) =>
	m.type === "VIDEO" || m.type === "video";

export const extractAudioUri = (content: BaseItemContent): string =>
	content.stimulus?.media?.find(isAudio)?.url ?? "";

export const extractVideoUri = (content: BaseItemContent): string =>
	content.stimulus?.media?.find(isVideo)?.url ?? "";

export const extractImages = (content: BaseItemContent): MediaItem[] =>
	(content.stimulus?.media ?? []).filter(isImage).map((m) => ({
		id: m.id,
		url: m.url,
		caption: m.metadata?.caption ?? m.caption,
	}));

export const extractItemAudioUri = (content: BaseItemContent): string =>
	content.media?.find(isAudio)?.url ?? "";

export const getItemAudioUri = (content?: BaseItemContent): string =>
	content ? extractAudioUri(content) || extractItemAudioUri(content) : "";

export const getItemVideoUri = (content?: BaseItemContent): string =>
	content ? extractVideoUri(content) : "";

export const extractItemImages = (content: BaseItemContent): MediaItem[] =>
	(content.media ?? []).filter(isImage).map((m) => ({
		id: m.id,
		url: m.url,
		caption: m.metadata?.caption ?? m.caption,
	}));

export const hasListeningItems = (sessionItems: BaseItemSchema[][]) => {
	return sessionItems.some((block) =>
		block.some(
			(item) =>
				item.metadata?.skill === "LISTENING" ||
				item.metadata?.skill === "SPEAKING",
		),
	);
};
